import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PartySource } from '@shared/party/enums';

@Component({
  selector: 'tablesready-party-source-badge',
  templateUrl: './party-source-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PartySourceBadgeComponent {
  @Input() source?: PartySource;
  private readonly partySourceLabels: Record<PartySource, string> = {
    [PartySource.noSource]: '',
    [PartySource.manager]: 'Man',
    [PartySource.public]: 'Pub',
    [PartySource.api]: 'Api',
    [PartySource.square]: 'Squ',
    [PartySource.sms]: 'Sms',
    [PartySource.google]: 'Goog',
  };
  private readonly partySourceTooltips: Record<PartySource, string> = {
    [PartySource.noSource]: '',
    [PartySource.manager]: 'Manager',
    [PartySource.public]: 'Public',
    [PartySource.api]: 'Api',
    [PartySource.square]: 'Square',
    [PartySource.sms]: 'Sms',
    [PartySource.google]: 'Google',
  };

  get label(): string {
    return this.partySourceLabels[this.source];
  }

  get tooltip(): string {
    return this.partySourceTooltips[this.source];
  }

  get classes() {
    const genericClasses = 'badge badge-pill';
    let colorClass = 'badge-success';
    switch (this.source) {
      case PartySource.public:
      case PartySource.api:
      case PartySource.sms:
        colorClass = 'badge-info';
        break;

      case PartySource.square:
      case PartySource.google:
        colorClass = 'badge-warning';
        break;
    }

    return `${genericClasses} ${colorClass}`;
  }
}
